// Result guarantee promised at the consult (CR-0042): lose/gain a kg range and/or an inches range.
// Stored on the consult as {weight: {dir, min, max} | null, inches: {...} | null}.
const PARTS = [["weight", "Weight", "kg"], ["inches", "Inches", "in"]];

const blank = (v) => v === "" || v == null;

// A plain message for what's wrong, or "" when it's fine (or empty).
export function guaranteeProblem(g) {
  for (const [key, label] of PARTS) {
    const p = g?.[key];
    if (!p || (blank(p.min) && blank(p.max))) continue;
    if (blank(p.min) || blank(p.max)) return `${label} guarantee: give both the lowest and the highest.`;
    const lo = Number(p.min), hi = Number(p.max);
    if (!Number.isFinite(lo) || !Number.isFinite(hi) || lo < 0 || hi <= 0) return `${label} guarantee: use positive numbers.`;
    if (lo > hi) return `${label} guarantee: the lowest is more than the highest.`;
  }
  return "";
}

// What gets saved: numbers, or null when nothing is filled in.
export function cleanGuarantee(g) {
  const out = {};
  for (const [key] of PARTS) {
    const p = g?.[key];
    out[key] = p && !blank(p.min) && !blank(p.max)
      ? { dir: p.dir === "gain" ? "gain" : "lose", min: Number(p.min), max: Number(p.max) } : null;
  }
  return out.weight || out.inches ? out : null;
}

const num = (n) => String(Number(n));

// "Lose 3–4 kg · Gain 2–3 in"
export function formatGuarantee(g) {
  if (!g) return "";
  return PARTS.map(([key, , unit]) => {
    const p = g[key];
    if (!p) return "";
    const range = Number(p.min) === Number(p.max) ? num(p.min) : `${num(p.min)}–${num(p.max)}`;
    return `${p.dir === "gain" ? "Gain" : "Lose"} ${range} ${unit}`;
  }).filter(Boolean).join(" · ");
}
